export default __webpack_public_path__ + "static/media/08-city.b57a73e4.jpg";